export interface DateRange {
    min: string;
    max: string;
}

/** Pure: compute min/max ISO strings from an array of {from, to} pairs. */
export function minMaxIso(items: Array<{ from: string; to: string }>): DateRange {
    let min = '';
    let max = '';
    for (const item of items) {
        if (item.from && (!min || item.from < min)) min = item.from;
        if (item.to && (!max || item.to > max)) max = item.to;
    }
    return { min, max };
}

/** DOM: read min/max from checked transport price checkboxes inside container. */
export function minMaxFromCheckedPrices(container: HTMLElement): DateRange {
    const cbs = Array.from(
        container.querySelectorAll<HTMLInputElement>('[name$=".SelectedOfferPriceIds"]:checked')
    );
    return minMaxIso(cbs.map(cb => ({
        from: cb.getAttribute('data-from') || '',
        to:   cb.getAttribute('data-to')   || '',
    })));
}

/** DOM: read the availability window from sub-range pickers' min/max attributes. */
export function availabilityBoundsFromContainer(container: HTMLElement): DateRange {
    let min = '';
    let max = '';
    container.querySelectorAll<HTMLInputElement>('.sub-range-from-picker').forEach(p => {
        if (p.min && (!min || p.min < min)) min = p.min;
    });
    container.querySelectorAll<HTMLInputElement>('.sub-range-to-picker').forEach(p => {
        if (p.max && (!max || p.max > max)) max = p.max;
    });
    return { min, max };
}

/**
 * DOM: read min/max dates from the container.
 * For sub-range groups: reads from the date picker inputs.
 * For transport groups: falls back to checked price checkboxes.
 */
export function minMaxFromContainer(container: HTMLElement): DateRange {
    const fromPickers = Array.from(container.querySelectorAll<HTMLInputElement>('.sub-range-from-picker'));
    if (fromPickers.length > 0) {
        const items = fromPickers.map(fp => {
            const unitId = fp.dataset.unitId;
            const toPicker = unitId
                ? container.querySelector<HTMLInputElement>(`.sub-range-to-picker[data-unit-id="${unitId}"]`)
                : null;
            return { from: fp.value || '', to: toPicker?.value || '' };
        }).filter(x => x.from && x.to);
        return minMaxIso(items);
    }
    return minMaxFromCheckedPrices(container);
}
